import { NavLink } from 'react-router-dom'

import { NAV_ITEMS, ROUTES, SITE } from '@/config/site'
import { useI18n } from '@/i18n'

import { Wordmark } from './Wordmark'

export function SiteFooter() {
  const { t } = useI18n()

  return (
    <footer className="hairline mt-8 bg-surface/40">
      <div className="gutter mx-auto grid max-w-7xl gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4 lg:py-16">
        <div className="sm:col-span-2">
          <Wordmark size="lg" />
          <p className="mt-5 max-w-sm text-sm text-muted">{t.footer.safety}</p>
        </div>

        <nav aria-label={t.footer.navHeading}>
          <h2 className="eyebrow mb-4">{t.footer.navHeading}</h2>
          <ul className="space-y-2.5">
            {[...NAV_ITEMS, { to: ROUTES.join, labelKey: 'join' as const }].map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === ROUTES.home}
                  className="text-sm text-muted transition-colors hover:text-gold"
                >
                  {t.nav[item.labelKey]}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="eyebrow mb-4">{t.footer.contactHeading}</h2>
          <ul className="space-y-2.5">
            <li>
              <a
                href={`mailto:${SITE.email}`}
                className="break-all text-sm text-muted transition-colors hover:text-gold"
              >
                {SITE.email}
              </a>
            </li>
            <li>
              <a
                href={SITE.instagram.url}
                target="_blank"
                rel="noreferrer noopener"
                className="text-sm text-muted transition-colors hover:text-gold"
              >
                Instagram {SITE.instagram.handle}
              </a>
            </li>
            <li className="text-sm text-faint">{t.common.basedIn}</li>
          </ul>
          <p className="mt-4 text-xs text-faint">{t.footer.dataNote}</p>
        </div>
      </div>

      <div className="hairline">
        <div className="gutter mx-auto flex max-w-7xl flex-col gap-2 py-6 text-xs text-faint sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} {SITE.name}. {t.footer.rights}
          </p>
          <p>2 · 8 · 2027</p>
        </div>
      </div>
    </footer>
  )
}
